import { IconFont, Menu, Tooltip } from '@byecode/ui'
import { useCurrentEditor } from '@tiptap/react'
import type { FC } from 'react'
import React from 'react'

import { isMobileDevice } from '../../../../utils/getApplicationPreviewType'
import { DropdownActionButton } from '../styles'

const OPTIONS = [
    { label: '0', value: '0' },
    { label: '8', value: '8' },
    { label: '16', value: '16' },
    { label: '24', value: '24' },
    { label: '32', value: '32' },
    { label: '40', value: '40' },
    { label: '48', value: '48' }
]

export const PreSegmentDistanceMenu: FC = () => {
    const { editor } = useCurrentEditor()

    const currentSize = editor?.getAttributes('paragraph').marginTop?.toString() || '0'

    return (
        <Menu zIndex={300} withinPortal width={120} trigger={isMobileDevice() ? 'click' : 'hover'} position="bottom">
            <Menu.Target>
                <Tooltip title="上间距">
                    <DropdownActionButton>
                        <IconFont size={16} type="BeforeParagraph" />
                        <IconFont size={10} type="ArrowDownSmallGray" color="var(--color-gray-500)" />
                    </DropdownActionButton>
                </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
                {OPTIONS.map(item => (
                    <Menu.Item
                        key={item.value}
                        style={currentSize === item.value ? { backgroundColor: 'var(--color-gray-100)' } : {}}
                        onClick={() =>
                            currentSize === item.value
                                ? editor?.chain().focus().unsetMarginTop().run()
                                : editor?.chain().focus().setMarginTop(item.value).run()
                        }
                    >
                        {item.label}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
